﻿import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { IBaseSubSectionProps } from "../SubSections";
import { IToolProps } from "../Tool";

export interface IDataFeedStatusSectionProps extends IBaseSectionProps {
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    functionCall: string;
    subSections: IBaseSubSectionProps[];
}

export const DataFeedStatusSection: React.FunctionComponent<
    IDataFeedStatusSectionProps
> = (props): React.ReactElement => {
    const bindOnClick = (): void => {
        const activeProps: IActiveSectionProps = {
                moduleID: props.moduleID,
                sectionType: props.sectionType,
                tower: {
                    bindComponent: null,
                },
            },
            tool: IToolProps = props.subSections[0].tools[0];

        // Toggle the section
        props.toggleSection(activeProps, activeSectionsComparer);

        props.bindToolToFrame(
            tool.moduleID,
            tool.name,
            tool.lookupName,
            tool.url,
        );
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            const sectionType = activeSections[i].sectionType;

            if (
                sectionType === `MyProfile` ||
                sectionType === `ToolMenu` ||
                sectionType === `Notifications` ||
                sectionType === `ReleaseNotes` ||
                sectionType === `DataFeedStatus` ||
                sectionType === `EditProfile`
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
